import {NgModule} from '@angular/core';
import {CtConfigPage} from "./page/overview/ct-config/ct-config.page";
import {CtDashboardPage} from "./page/overview/ct-dashboard/ct-dashboard.page";
import {AgentProcessingPage} from "./page/agent-processing/agent-processing.page";
import {CT_ENTITY_PROVIDER} from "./ct.entity-provider";
import {ConfirmationService} from 'primeng/api';
import {MvsConfirmationService} from "../../core/shared/service/confirmation/mvs-confirmation.service";
import {CoreModule} from "../../core/core.module";
import {
    SelectionCriteriaBuilderComponent
} from "./component/selection-criteria-builder/selection-criteria-builder.component";
import {
    CampaignMemberAssignmentComponent
} from "./component/campaign-member-assignment/campaign-member-assignment.component";
import {CampaignKpiTileComponent} from "./component/campaign-kpi-tile/campaign-kpi-tile.component";
import {CampaignKpiDashboardPage} from "./page/campaign-kpi-dashboard/campaign-kpi-dashboard.page";
import {CampaignComparisonPage} from "./page/campaign-comparison/campaign-comparison.page";
import {AgentPerformanceAnalyticsPage} from "./page/agent-performance-analytics/agent-performance-analytics.page";
import {
    SelectionCriteriaVersionHistoryComponent
} from "./component/selection-criteria-version-history/selection-criteria-version-history.component";
import {AiSegmentSuggestionsComponent} from "./component/ai-segment-suggestions/ai-segment-suggestions.component";
import {
    AiNaturalLanguageInputComponent
} from "./component/ai-natural-language-input/ai-natural-language-input.component";
import {
    NaturalLanguageCriteriaSessionComponent
} from "./component/natural-language-criteria-session/natural-language-criteria-session.component";
import {ABTestManagerComponent} from "./component/ab-test-manager/ab-test-manager.component";
import {MobileAgentProcessingPage} from "./page/mobile-agent-processing/mobile-agent-processing.page";
import {CampaignCalendarComponent} from "./component/campaign-calendar/campaign-calendar.component";
import {CampaignCalendarPage} from "./page/campaign-calendar-page/campaign-calendar.page";
// TODO: FullCalendar-Dependency entfernt. CampaignCalendarComponent muss auf eigene Kalenderlogik (AgentCalendarComponent/Scheduler) umgebaut werden.
// import {FullCalendarModule} from "@fullcalendar/angular";
import {
    PropensityScoringManagerComponent
} from "./component/propensity-scoring-manager/propensity-scoring-manager.component";
import {
    ExternalIntegrationManagerComponent
} from "./component/external-integration-manager/external-integration-manager.component";
import {CampaignROIDashboardPage} from "./page/campaign-roi-dashboard/campaign-roi-dashboard.page";
import {CampaignBulkOperationsComponent} from "./component/campaign-bulk-operations/campaign-bulk-operations.component";
import {CampaignCloneDialogComponent} from "./component/campaign-clone-dialog/campaign-clone-dialog.component";
import {
    EventSubscriptionManagerComponent
} from "./component/event-subscription-manager/event-subscription-manager.component";
import {WebhookManagerComponent} from "./component/webhook-manager/webhook-manager.component";
import {RealTimeCountComponent} from "./component/real-time-count/real-time-count.component";
import {
    CampaignTypeConfigObjectComponent
} from "./component/protected-components/object-component/campaign-type-config-object-component/campaign-type-config-object.component";
import {
    CampaignTypeConfigObjectBaseComponent
} from "./component/protected-components/object-component/campaign-type-config-object-component/view/campaign-type-config-object-base.component";
import {
    CampaignTypeConfigObjectFullComponent
} from "./component/protected-components/object-component/campaign-type-config-object-component/view/campaign-type-config-object-full/campaign-type-config-object-full.component";
import {
    CampaignTypeConfigObjectSideComponent
} from "./component/protected-components/object-component/campaign-type-config-object-component/view/campaign-type-config-object-side/campaign-type-config-object-side.component";


@NgModule({
    declarations: [
        CtConfigPage,
        CtDashboardPage,
        AgentProcessingPage,
        SelectionCriteriaBuilderComponent,
        CampaignMemberAssignmentComponent,
        CampaignKpiTileComponent,
        CampaignKpiDashboardPage,
        CampaignComparisonPage,
        AgentPerformanceAnalyticsPage,
        SelectionCriteriaVersionHistoryComponent,
        AiSegmentSuggestionsComponent,
        AiNaturalLanguageInputComponent,
        NaturalLanguageCriteriaSessionComponent,
        ABTestManagerComponent,
        MobileAgentProcessingPage,
        CampaignCalendarComponent,
        CampaignCalendarPage,
        PropensityScoringManagerComponent,
        ExternalIntegrationManagerComponent,
        CampaignROIDashboardPage,
        CampaignBulkOperationsComponent,
        CampaignCloneDialogComponent,
        EventSubscriptionManagerComponent,
        WebhookManagerComponent,
        RealTimeCountComponent,
        CampaignTypeConfigObjectComponent,
        CampaignTypeConfigObjectBaseComponent,
        CampaignTypeConfigObjectFullComponent,
        CampaignTypeConfigObjectSideComponent,
    ],
    exports: [
        CtConfigPage,
        CtDashboardPage,
        AgentProcessingPage,
        SelectionCriteriaBuilderComponent,
        CampaignMemberAssignmentComponent,
        CampaignKpiTileComponent,
        CampaignKpiDashboardPage,
        CampaignComparisonPage,
        AgentPerformanceAnalyticsPage,
        SelectionCriteriaVersionHistoryComponent,
        AiSegmentSuggestionsComponent,
        AiNaturalLanguageInputComponent,
        NaturalLanguageCriteriaSessionComponent,
        ABTestManagerComponent,
        MobileAgentProcessingPage,
        CampaignCalendarComponent,
        CampaignCalendarPage,
        PropensityScoringManagerComponent,
        ExternalIntegrationManagerComponent,
        CampaignROIDashboardPage,
        CampaignBulkOperationsComponent,
        CampaignCloneDialogComponent,
        EventSubscriptionManagerComponent,
        WebhookManagerComponent,
        RealTimeCountComponent,
        CampaignTypeConfigObjectComponent,
        CampaignTypeConfigObjectBaseComponent,
        CampaignTypeConfigObjectFullComponent,
        CampaignTypeConfigObjectSideComponent,
    ],
    imports: [
        CoreModule,
        // TODO: FullCalendarModule entfernt - CampaignCalendar auf eigene Kalenderlogik umbauen
        // FullCalendarModule,
    ],
    providers: [CT_ENTITY_PROVIDER, {provide: ConfirmationService, useClass: MvsConfirmationService}]
})
export class CtModule {
}
